const validationMessages = {
    unknown: "Unknown error",
    validation: "Validation error",
    required: "Required field. Please add a ",
    maxLength: "Max Length is ",
    duplicated: "Duplicated",
};

export default validationMessages;
